<app-splash *ngIf="!loaded"></app-splash>
<div *ngIf="connection.offline" class="offline-badge">
    <i class="fa fa-wifi"></i>
    <span>Sin conexión</span>
</div>
<a *ngIf="isLogged && dbService.pendingCount > 0" routerLink="/fotos-pendientes" class="pending-photos-badge">
    <i class="fa fa-cloud-upload"></i>
    <span>{{ dbService.pendingCount }} {{ dbService.pendingCount === 1 ? 'foto pendiente' : 'fotos pendientes' }}</span>
</a>
<app-login *ngIf="!isLogged"></app-login>
<router-outlet *ngIf="isLogged"></router-outlet>
